import { Injectable, inject, signal } from '@angular/core';

const TOKEN_STORAGE_KEY = 'catch.candidate.jwt';

@Injectable({
  providedIn: 'root',
})
export class PlatformAuthTokenService {
  private readonly tokenState = signal<string | null>(this.read());

  readonly token = this.tokenState.asReadonly();

  /**
   * Stores or clears the candidate JWT used for platform API calls.
   * @param token - JWT or null to sign out locally
   */
  set(token: string | null): void {
    if (typeof window === 'undefined') {
      this.tokenState.set(token);
      return;
    }
    if (token) {
      window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
    } else {
      window.localStorage.removeItem(TOKEN_STORAGE_KEY);
    }
    this.tokenState.set(token);
  }

  /**
   * @returns Stored JWT or null
   */
  private read(): string | null {
    if (typeof window === 'undefined') {
      return null;
    }
    return window.localStorage.getItem(TOKEN_STORAGE_KEY);
  }
}
